import React from 'react';
import { Box, Button, SxProps } from '@mui/material';
import { useDispatch } from 'react-redux';
import { createAnalytics } from '../../../../store/AnalyticsSlice';
import { useAppSelector } from '../../../../hooks';
import { getAuthState } from '../../../../store/AuthSlice';

const boxProps: SxProps = {
  mt: '25px',
  color: 'white',
  backgroundColor: '#1E293B',
  padding: '15px 30px',
  zIndex: 1000,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: '10px',
  flexDirection: { xs: 'column', sm: 'row' },
};

interface IBannerProps {
  open: boolean;
  onClose: () => void;
}

const TheoryQuestionsPreferenceBanner: React.FC<IBannerProps> = ({
  open,
  onClose,
}) => {
  const authState = useAppSelector(getAuthState);
  const authUser = authState.user;
  const dispatch = useDispatch();

  const handleButtonClick = (response: string) => {
    dispatch(
      createAnalytics({
        type: 'LP - Theory questions preference',
        data: {
          userResponse: response,
          userEmail: authUser?.email,
          userFirstName: authUser?.firstname,
          userLastName: authUser?.lastname,
          userRole: authUser?.role.name,
        },
        userId: authUser?._id,
      })
    );
    onClose();
  };

  return (
    <Box sx={boxProps}>
      <Box
        sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0, sm: 2 } }}
      >
        <span>Would you like us to add theory questions here?</span>
        <img
          alt="folder"
          src={`${process.env.PUBLIC_URL}/images/pastPaperPage/books.png`}
          width="20px"
          height="20px"
        />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }}>
        <Button
          onClick={() => handleButtonClick('Yes')}
          sx={{
            color: 'white',
            textTransform: 'none',
            padding: '0',
            minWidth: 'auto',
          }}
        >
          Yes
        </Button>
        <span style={{ margin: '0 15px' }}>|</span>
        <Button
          onClick={() => handleButtonClick('No')}
          sx={{
            color: 'white',
            textTransform: 'none',
            padding: '0',
            minWidth: 'auto',
          }}
        >
          No
        </Button>
      </Box>
    </Box>
  );
};

export default TheoryQuestionsPreferenceBanner;
